import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Button, Container, Form, FormGroup, Input, Label, Row, Col } from 'reactstrap';
import * as actions from '../actions/Course';
import { clearSearchedCourses, searchCourses, searchUnassignedSections } from '../actions/Search';
import List from '../components/course/List';
import Breadcrumb from '../components/AdminBreadcrumb';


class Course extends React.Component {

    handleSave = () => {
        const { name, description } = this.props.course.toJS();

        if (name || description) {
            this.props.actions.updateCourse(this.props.course.set('sessionId', this.props.currentSessionId));
        }
    };

    componentDidMount() {
        if (this.props.match.params && this.props.match.params.id !== this.props.course.get('courseId'))
            this.props.actions.getCourse(this.props.match.params.id);
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.props.actions.setField(name, value);
    }

    handleSelect = (id) => {
        const { courseId, parentCourseId } = this.props.course.toJS();
        this.props.actions.getCourse(id);

        //If we have a parent course id then we are navigating to a learner outcome for a section.
        //Otherwise we are navigating to a section for a course.
        if (this.props.isCourseView) {
            this.props.history.push(parentCourseId ? `/courses/course/${parentCourseId}/section/${courseId}/learneroutcome/${id}` : `/courses/course/${courseId}/section/${id}`, { id });
        }
        else {
            this.props.history.push(`/sections/section/${courseId}/learneroutcome/${id}`);
        }

    };

    handleDelete = (id) => this.props.actions.deleteSection(this.props.course.get('courseId'), id);

    handleCreate = () => {
        const { courseId, parentCourseId } = this.props.course.toJS();

        this.props.actions.newCourse(courseId);

        //If we have a parent course id then we are creating a learner outcome for a section.
        //Otherwise we are creating a section for a course.
        this.props.history.push(parentCourseId ? `/courses/course/${parentCourseId}/section/${courseId}/learneroutcome` : `/courses/course/${courseId}/section`);
    }

    handleSearch = (searchTerm) => this.props.actions.searchUnassignedSections(this.props.currentSessionId, searchTerm);

    handleAddFromSearch = (selectedCourses) => this.props.actions.copySectionToCourse(this.props.course.get('courseId'), selectedCourses.map(x => x.courseId));

    render() {
        const { courseId, name, description, sections, parentCourseId } = this.props.course.toJS();
        const desc = this.props.course.get('description')
        const showNameField = !this.props.history.location.pathname.includes('learneroutcome') ?
            <React.Fragment>
                <Row>
                    <Col>
                        <FormGroup>
                            <Label>Name:</Label>
                            <Input type='text' name='name' invalid={!name}  onChange={this.handleChange} required value={name || ''} />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment> : null

        return (
            <Container>
                <div style={{ paddingBottom: '10px' }}>
                    <Breadcrumb history={this.props.history} />
                </div>
                <Form>
                    {showNameField}
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>Description:</Label>
                                <Input type='textarea' rows='5' name='description' onChange={this.handleChange} value={description || ''} />
                            </FormGroup>
                        </Col>
                    </Row>
                    {(courseId && !this.props.match.params.sectionId) &&
                        <Row className='pb-1'>
                            <Col>
                            <List
                                    clearSearchedCourses={this.props.actions.clearSearchedCourses}
                                    title={parentCourseId ? 'Learner Outcomes:' : 'Sessions:'}
                                    hideSearchButton={parentCourseId}
                                    courses={sections}
                                    onDelete={this.handleDelete}
                                    onSelect={this.handleSelect}
                                    onAdd={this.handleCreate}
                                    onSearch={this.handleSearch}
                                    searchResults={this.props.searchResults && this.props.searchResults.toJS()}
                                    onAddFromSearch={this.handleAddFromSearch}
                                    searchTitle='Search Sessions'
                                    hideNameField={this.props.history.location.pathname.includes('section')}
                                />
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col>
                            <Button className={'float-right'} disabled={!name && !desc} onClick={this.handleSave}>Save</Button>
                        </Col>
                    </Row>

                </Form >

            </Container>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        course: state.Course,
        isCourseView: ownProps.location.pathname.startsWith("/courses"),
        searchResults: state.SearchResults.get('courses'),
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions, clearSearchedCourses, searchCourses, searchUnassignedSections }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Course);